module.exports = __webpack_public_path__ + "img/mi.5117f390.svg";